module.exports = "./app-dist/templates/message.68cbaf4ecd30e79771e63b5f0c84c2e1.html";